import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import LanguageDetect from 'languagedetect';
import { errorTypes, statusCampaign } from '@/helpers/constants';
import { setCampaignInfo } from '@/redux/Campaign/campaign.action';
import { Language } from '@/types';
import useToastContext from './useToastContext';

const useDetectLanguage = () => {
  const { addToast } = useToastContext();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { defaultLanguage, translations, campaignInfo } = useSelector((state: any) => ({
    defaultLanguage: state.campaignReducer?.info?.defaultLanguage,
    translations: state.campaignReducer?.translations?.modules,
    campaignInfo: state.campaignReducer?.info,
    validations: state.campaignReducer?.validations,
  }));

  const detectLanguageTranslation = (label: string, plant?: string, modelId?: number) => {
    let input;

    if (plant) {
      const getPlant = translations?.AFFECTED_VEHICLES?.translatablePropertiesByPlant?.find((s: any) => s.plant.wkzNumber === plant);
      const getGroup = modelId !== undefined ? getPlant?.translatablePropertiesByGroup[modelId] : undefined;
      input = (modelId !== undefined ? getGroup : getPlant)?.translatableProperties?.find((codes) => codes.code === label);
    } else {
      if (!translations || translations.length === 0)
        return;

      Object.values(translations)?.find((module) => {
        const foundTranslation = (module as any)?.translatableProperties[label]?.translations;

        if (foundTranslation) {
          input = foundTranslation;

          return true;
        }

        return false;
      });
    }

    const IsTranslatedField = defaultLanguage === Language.EN ? (input?.DE || input?.translations?.DE) : (input?.EN || input?.translations?.EN);

    if (IsTranslatedField && campaignInfo.status === statusCampaign.IN_CREATION) {
      dispatch(setCampaignInfo({ ...campaignInfo, isTranslationUpdateNeeded: true }, false));

      return addToast(t('campaign.translationChangeWarning', { defaultLanguage }), 'Warning', errorTypes.LANGUAGE_WARNING_TRANSLATIONS);
    }
  };

  const detectLanguage = (text: string, isTranslation: boolean = false) => {
    if (!text?.trim()) return;

    const translationLanguage = defaultLanguage === 'EN' ? 'DE' : 'EN';
    const language = isTranslation ? translationLanguage : defaultLanguage;
    const langDetector = new LanguageDetect();
    const detectedLanguage = langDetector.detect(text)
      .filter((lang) => ['german', 'english'].includes(lang[0]))
      .map((lang) => (lang[0] === 'english' ? 'EN' : 'DE'))[0];
    const lang = t(`languageChip.${isTranslation ? translationLanguage : defaultLanguage}`);

    if (!detectedLanguage) {
      return addToast(t('campaign.languageWarning', { lang }), 'Warning', errorTypes.LANGUAGE_WARNING);
    }

    if (language !== detectedLanguage) {
      return addToast(t(`campaign.${isTranslation ? 'languageWarningTranslations' : 'languageWarning'}`, { lang }), 'Warning',
        isTranslation ? errorTypes.LANGUAGE_WARNING_TRANSLATIONS : errorTypes.LANGUAGE_WARNING);
    }
  };

  return { detectLanguage, detectLanguageTranslation };
};

export default useDetectLanguage;
